import { Controller } from "@hotwired/stimulus"

// Sets the user's timezone as a cookie so Rails can use it for time formatting.
// Attach to document body with: data-controller="timezone-cookie"
export default class extends Controller {
  connect() {
    this.#setTimezoneCookie()
  }

  #setTimezoneCookie() {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const secure = location.protocol === "https:" ? "; Secure" : ""
    document.cookie = `timezone=${encodeURIComponent(timezone)}; path=/; SameSite=Lax${secure}`
  }
}
